import { SnackbarOrigin } from "@mui/material/Snackbar";
import { action, observable, makeObservable } from "mobx";

interface Snack extends SnackbarOrigin {
  messageId?: string;
  message: string;
  autoHideDuration?: number;
  variant: "success" | "error" | "info" | "warning";
}

export default class SnackStore {
  snacks: Snack[] = [];

  constructor() {
    makeObservable<SnackStore, "show">(this, {
      snacks: observable,
      show: action.bound
    });
  }

  private show(snack: Snack) {
    snack.messageId = (Math.random() * 100000).toString();
    this.snacks = this.snacks.concat(snack);
  }

  public showResult(success: boolean = true) {
    if (success) this.showSuccess();
    else this.showError();
  }

  public showSuccess(message: string = "Success") {
    this.show({
      autoHideDuration: 2500,
      horizontal: "right",
      vertical: "bottom",
      message: message,
      variant: "success"
    });
  }

  public showWarning(message: string = "Warning") {
    this.show({
      autoHideDuration: 2500,
      horizontal: "right",
      vertical: "bottom",
      message: message,
      variant: "warning"
    });
  }

  public showError(message: string = "Error") {
    this.show({
      autoHideDuration: 2500,
      horizontal: "right",
      vertical: "bottom",
      message: message,
      variant: "error"
    });
  }

  public remove(snack: Snack) {
    this.snacks = this.snacks.filter(s => s.messageId !== snack.messageId);
  }
}